// Utilizando o objeto window.amplitude em vez das importações

// Configuração e inicialização do Session Replay
const initAmplitude = (user = {}) => {
  // O Amplitude já foi inicializado via CDN no HTML

  // Identificar o usuário, se disponível
  if (user && user.id) {
    window.amplitude.setUserId(user.id);

    // Configurar propriedades do usuário
    const identify = new window.amplitude.Identify();
    identify.set('email', user.email);
    identify.set('dealershipName', user.dealershipName);
    identify.set('isNinja', user.isNinja ? user.isNinja() : false);
    window.amplitude.identify(identify);
  }

  return window.amplitude;
};

// Método para rastrear eventos específicos
export const trackEvent = (eventName, eventProperties = {}) => {
  if (!eventName || !window.amplitude) return;
  window.amplitude.track(eventName, eventProperties);
};

// Método para capturar propriedades de sessão para enviar com outros eventos
export const getSessionReplayProperties = () => {
  if (!window.sessionReplay) return {};
  return window.sessionReplay.getSessionReplayProperties?.() || {};
};

export default initAmplitude;
